import { useCallback } from 'react'
import { getValidAccessToken } from 'utils/aws/authService'
import { AccountAssumption } from 'admin/utils/AccountAssumption'
import { getApiUrl } from 'utils/api/getApiUrl'

export const useApi = () => {
  const apiUrl = getApiUrl()
  const apiRequest = useCallback(
    async (endpoint, fetchOptions = {}) => {
      const token = await getValidAccessToken()
      // unneccessary wrapper unless adding retries or metrics/logging - testing remove
      // const makeRequest = async () => {
      const headers = {
        Authorization: `Bearer ${token}`,
        ...fetchOptions.headers,
      }
      // only add assumed user if it exists
      const assumedUser = await AccountAssumption.assumedAs()
      if (assumedUser) {
        headers['Assumed-User'] = assumedUser
      }
      const result = await fetch(`${apiUrl}${endpoint}`, {
        headers,
        ...fetchOptions,
      })
      return result
      // }
      // return await makeRequest()
    },
    [apiUrl]
  )
  return { apiRequest }
}
